import home from "./home";
import user from "./user";
import safety from "./safety";
import file from "./file";
import code from "./code";
import userUrl from "./user_url";
import token from "./token";
import userToken from "./user_token";
import userTokenRecord from "./user_token_record";
import country from "./country";
import server from "./server";
import userServer from "./user_server";
import userServerRecord from "./user_server_record"
import userWalletLog from "./user_wallet_log"
import userWallet from "./user_wallet"
import chain from "./chain"
import chat from "./chat"
import notice from "./notice"
import activity from "./activity"

export default {
  home,
  file,
  user,
  safety,
  code,
  userUrl,
  token,
  userToken,
  country,
  server,
  userServer,
  userTokenRecord,
  userServerRecord,
  userWalletLog,
  userWallet, 
  chain,
  chat,
  notice,
  activity
};
